import { z } from 'zod';
import { trainingCommandIdSchema, trainingContentKeySchema, trainingCourseIdSchema, trainingReleaseIdSchema, } from './training-content.contract.js';
export const trainingAssignmentsCapability = 'training.assignments.v1';
export const trainingProgressCapability = 'training.progress.v1';
export const trainingAssignmentIdSchema = z.string().uuid();
export const trainingAssignmentStatusSchema = z.enum(['assigned', 'in-progress', 'completed', 'waived']);
export const trainingProgressStateSchema = z.enum(['not-started', 'in-progress', 'completed']);
export const trainingAssignmentSchema = z.strictObject({
    id: trainingAssignmentIdSchema,
    tenantId: z.string().uuid(),
    courseId: trainingCourseIdSchema,
    releaseId: trainingReleaseIdSchema,
    membershipId: z.string().uuid(),
    status: trainingAssignmentStatusSchema,
    dueAt: z.string().datetime({ offset: true }).nullable(),
    revision: z.number().int().positive(),
    assignedByMembershipId: z.string().uuid(),
    assignedAt: z.string().datetime({ offset: true }),
    completedAt: z.string().datetime({ offset: true }).nullable(),
    waivedAt: z.string().datetime({ offset: true }).nullable(),
});
export const trainingProgressSchema = z.strictObject({
    tenantId: z.string().uuid(),
    membershipId: z.string().uuid(),
    courseId: trainingCourseIdSchema,
    releaseId: trainingReleaseIdSchema,
    assignmentId: trainingAssignmentIdSchema.nullable(),
    state: trainingProgressStateSchema,
    completedLessonKeys: z.array(trainingContentKeySchema),
    completionPercentage: z.number().int().min(0).max(100),
    assessmentPassed: z.boolean(),
    revision: z.number().int().positive(),
    startedAt: z.string().datetime({ offset: true }),
    completedAt: z.string().datetime({ offset: true }).nullable(),
});
export const trainingCreateAssignmentSchema = z.strictObject({
    commandId: trainingCommandIdSchema,
    courseId: trainingCourseIdSchema,
    membershipId: z.string().uuid(),
    dueAt: z.string().datetime({ offset: true }).nullable().default(null),
    reason: z.string().trim().min(5).max(500),
});
export const trainingWaiveAssignmentSchema = z.strictObject({
    commandId: trainingCommandIdSchema,
    expectedRevision: z.number().int().positive(),
    reason: z.string().trim().min(10).max(500),
});
export const trainingCompleteLessonSchema = z.strictObject({
    commandId: trainingCommandIdSchema,
    courseId: trainingCourseIdSchema,
    releaseId: trainingReleaseIdSchema,
    lessonKey: trainingContentKeySchema,
    expectedRevision: z.number().int().nonnegative().nullable().default(null),
});
export const trainingAssignmentsQuerySchema = z.strictObject({
    scope: z.enum(['mine', 'all']).default('mine'),
    includeWaived: z.boolean().default(false),
    limit: z.number().int().min(1).max(200).default(100),
    offset: z.number().int().min(0).default(0),
});
export const trainingAssignmentResponseSchema = z.strictObject({
    data: trainingAssignmentSchema,
    command: z.strictObject({ commandId: trainingCommandIdSchema, idempotent: z.boolean() }),
});
export const trainingAssignmentsResponseSchema = z.strictObject({
    data: z.array(trainingAssignmentSchema),
    page: z.strictObject({
        limit: z.number().int().positive(), offset: z.number().int().nonnegative(),
        returned: z.number().int().nonnegative(), total: z.number().int().nonnegative(),
    }),
});
export const trainingProgressResponseSchema = z.strictObject({
    data: trainingProgressSchema,
    command: z.strictObject({ commandId: trainingCommandIdSchema, idempotent: z.boolean() }),
});
//# sourceMappingURL=training-learning.contract.js.map